'use client';

import { Box, Typography, useTheme } from '@mui/material';

export interface TextAvatarProps {
  text: string;
  size?: number;
  color?: string;
  sx?: object;
}

const getInitials = (text: string) => {
  if (!text) return '?';
  const words = text.trim().split(/\s+/);
  if (words.length === 1) {
    return text.substring(0, 3).toUpperCase();
  }
  return words
    .slice(0, 3)
    .map((w) => w.charAt(0))
    .join('')
    .toUpperCase();
};

export const TextAvatar = ({ text, size = 40, color, sx = {} }: TextAvatarProps) => {
  const theme = useTheme();
  const displayLetters = getInitials(text);
  const bgColor = color || theme.palette.primary.main;

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '0.5rem',
        bgcolor: bgColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        boxShadow: 'inset 0 2px 4px rgba(255,255,255,0.1), inset 0 -2px 4px rgba(0,0,0,0.1)',
        ...sx,
      }}
    >
      <Typography
        sx={{
          color: theme.palette.common.white,
          fontWeight: 800,
          fontSize: displayLetters.length > 2 ? size * 0.25 : size * 0.35,
          letterSpacing: displayLetters.length > 1 ? '1px' : 'normal',
        }}
      >
        {displayLetters}
      </Typography>
    </Box>
  );
};
